import { Check } from "lucide-react";

function Tile({ s, on, toggle, testid, heightClass }) {
  return (
    <button
      type="button"
      onClick={() => toggle(s.id)}
      className={`relative flex ${heightClass} flex-col items-center justify-center gap-1.5 rounded-[var(--card-radius)] border p-3 text-center transition-all duration-200 ${
        on ? "border-[var(--accent)] bg-[var(--accent)]/10 shadow-lg shadow-[var(--accent-glow)]" : "border-[var(--border-subtle)] bg-[var(--bg-card)] hover:border-[var(--text-muted)]"
      }`}
      data-testid={testid}
    >
      {on && (
        <span className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-[var(--accent)] text-[var(--accent-contrast)]">
          <Check size={13} />
        </span>
      )}
      {s.logo ? (
        <img src={s.logo} alt="" className="svc-logo h-7 w-7 rounded object-cover" />
      ) : null}
      <span className="font-head text-base leading-tight tracking-wide break-words" style={s.color ? { color: s.color } : undefined}>
        {s.name}
      </span>
    </button>
  );
}

function Grid({ list, selected, toggle, testidPrefix, heightClass }) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
      {list.map((s) => (
        <Tile key={s.id} s={s} on={selected.has(s.id)} toggle={toggle} testid={`${testidPrefix}-${s.id}`} heightClass={heightClass} />
      ))}
    </div>
  );
}

export default function ServicePicker({ services, grouped, selected, toggle, testidPrefix, heightClass = "h-28" }) {
  if (!grouped) {
    return <Grid list={services} selected={selected} toggle={toggle} testidPrefix={testidPrefix} heightClass={heightClass} />;
  }
  const stream = services.filter((s) => s.kind !== "rent_buy");
  const rentBuy = services.filter((s) => s.kind === "rent_buy");
  return (
    <div className="space-y-5" data-testid={`${testidPrefix}-grouped`}>
      {stream.length > 0 && (
        <div>
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Stream</p>
          <Grid list={stream} selected={selected} toggle={toggle} testidPrefix={testidPrefix} heightClass={heightClass} />
        </div>
      )}
      {rentBuy.length > 0 && (
        <div>
          <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--text-secondary)]">Rent / Buy</p>
          <Grid list={rentBuy} selected={selected} toggle={toggle} testidPrefix={testidPrefix} heightClass={heightClass} />
        </div>
      )}
    </div>
  );
}
